import { Input } from '@/components/ui/input';

/**
 * One numeric alert setting: saves on blur when the value is a whole number in
 * range and changed. Uncontrolled, so a parent remounts it (via `inputKey`) to
 * show a value put back after a rejected save.
 */
export function AlertNumberKnob({ label, value, min, max, disabled, inputKey, onSave }: {
  label: string;
  value: number;
  min: number;
  max?: number;
  disabled: boolean;
  inputKey: string;
  onSave: (value: number) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-xs text-muted-foreground">
      {label}
      <Input
        key={inputKey}
        type="number"
        min={min}
        max={max}
        className="w-20 h-8 bg-card border-border tabular-nums"
        defaultValue={value}
        disabled={disabled}
        onBlur={event => {
          const next = Number(event.target.value);
          if (!Number.isInteger(next) || next < min || (max !== undefined && next > max) || next === value) return;
          onSave(next);
        }}
      />
    </label>
  );
}
